import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The mind of a wandering software poet",
  "description": "",
  "published": "2008-10-09T00:00:00.000Z",
  "redirect_from": ["/blog/the-mind-of-a-wandering-software-poet/swizec/59"],
  "categories": "art, creation, food for thought",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`_`}{`The mind of a wandering software poet `}{`_`}{`is a piece trying to depict what the true creators of software think like. We all know there are many coders out there who think of themselves as good, but they are not artists and it is only the true artists in software development that create beauty through code, magnificence through design and otherwise make a true art out of the craft. Everyone else is just mindles peons bashing at their keyboards, making products people hate and despise.`}</p>
    <p>{`Beautiful design, however, often goes unnoticed. People don't see the code, managers don't care for beauty and sexy, all they care about is productivity. This is why, with this piece of art, I sought to point out the clash between what a programmer wants and what they are forced into doing by circumstance. The roses depict seeking ultimate beauty while the small and scattered chrisantemes try to show how much random nuissance comes into play with development.`}</p>
    <p>{`Scattering the pieces of paper with code amongst the beauty I tried to show the way a true programmer thinks - constantly scraping code that is less than perfect, constantly thinking in several threads, keeping wildly different parts of the project in their mind at all times. These papers then try to live amongst the petals in hopes of learning from them, in hopes of improving, of becoming as beautiful and perfect as The Rose.`}</p>
    <p>{`The background is transparency, the foreground a computer GUI, these depict clairvoyance to see far ahead - predicting problems before they arise, and the basic tool of every programmer.`}</p>
    <p>{`Good code is poetry.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      